import { InjectionToken } from '@angular/core';
import { ICommonModuleConfig } from './ICommonModuleConfig';

/**
 * @public
 */
export const COMMON_MODULE_CONFIG = new InjectionToken<ICommonModuleConfig>('Common Module Configuration');
